<template>
	<el-dialog
		:visible.sync="dialogVisible"
		title="用户照片更新"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:modal-append-to-body="false"
		width="1000px">
		<div class="upload-box">
			<div class="upload-left">
				<p class="upload-title mt10">上传用户照片</p>
				<div class="upload-wrapper">
					<el-upload
						ref="upload"
						drag
						multiple
						:show-file-list="false"
						:action="action"
						:headers="headers"
						:file-list="files"
						:before-upload="handleBeforeUpload"
						:on-change="handleChange"
						:on-error="handleError"
						:on-success="handleSuccess">
						<div class="upload-info">
							<div class="upload-image mr8">
								<img :src="uploadimg" />
							</div>
							<div class="upload-tip">
								<div class="message info-text">点击或将文件拖拽到这里上传</div>
								<div class="tip">{{ message }}</div>
							</div>
						</div>
					</el-upload>
				</div>
			</div>
			<div class="upload-right">
				<p class="upload-title">照片列表<span class="tip">（格式：公司名-学员ID-姓名）</span></p>
				<div class="upload-files">
					<div class="file-item" v-for="(item, index) in files" :key="index">
						<div class="file-name">
							<img src="@/assets/images/file.png" alt="" />
							{{ item.name }}
						</div>
						<div class="file-perc">
							<span>{{ item.response && item.code != '0' ? "上传失败" : item.percentage == 100 || item.response && item.code == '0' ? "上传成功" : "上传中" }}</span>
							<span>{{ formatBytes(item.size) }}</span>
							<i class="el-icon-circle-close ddelete-icon" @click="deleteFile(index)"></i>
						</div>
						<el-progress :percentage="item.percentage" :color="item.response && item.code != '0' ? '#ff0000' : '#67C23A'"></el-progress>
						<p class="error" v-if="item.response && item.code != '0'">{{ item.message }}</p>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">返回</el-button>
			<!--<el-button type="primary" @click="handleSubmit" :loading="isUploading" :disabled="isUploading">确认</el-button>-->
		</span>
	</el-dialog>
</template>
<script>
// 引入配置文件
const defaultSettings = require("@/settings.js");
// 接口地址
const hostName = defaultSettings.hostName;
export default {
	data() {
		return {
			dialogVisible: false,
			uploadimg: require("@/assets/images/upload.png"),
			fileimg: require("@/assets/images/file.png"),
			disabled: false,
			headers: {
				token: `${window.sessionStorage.getItem("token")}`,
			},
			limit: 20,
			action: `${hostName}bsi/sysUser/addFileOss`,
			files: [],
			message: "单次最多上传20张图片（支持扩展名：jpg,jpeg,png）",
		};
	},
	// 修改点 2：新增 computed 属性
	computed: {
		// 判断是否有文件正在上传中
		isUploading() {
			// Element UI 的 file 对象有 status 属性：ready, uploading, success, fail
			// 只要有一个文件处于 uploading 状态，就返回 true
			return this.files.some((file) => file.status === "uploading");
		},
	},
	methods: {
		// 显示弹窗
		init() {
			this.dialogVisible = true;
			// 修复后的init方法
			this.$nextTick(() => {
				if (this.$refs.upload) {
					this.$refs.upload.clearFiles();
				}
				this.files = [];
			});
		},
		// 上传前的钩子
		handleBeforeUpload(file) {
			return true;
		},
		// 文件状态改变时的钩子
		handleChange(file, fileList) {
			this.files = fileList;
		},
		// 上传失败的钩子
		handleError(err, file, fileList) {},
		// 上传成功的钩子
		handleSuccess(response, file, fileList) {
			file.code = response.code;
			file.message = response.msg || "上传成功";
			response.code == "0" ? (file.fileUrl = response.data) : null;
		},
		// 辅助函数：去除末尾的".00"
		removeTrailingZero(numStr) {
			return numStr.replace(/\.00$/, "");
		},
		formatBytes(size) {
			if (size == 0 || isNaN(size)) return "0 B"; // 处理0或非数字输入

			if (size < 1024) {
				return size + " B";
			} else if (size < 1024 * 1024) {
				const sizeInKB = (size / 1024).toFixed(2);
				return this.removeTrailingZero(sizeInKB) + " KB";
			} else if (size < 1024 * 1024 * 1024) {
				const sizeInMB = (size / (1024 * 1024)).toFixed(2);
				return this.removeTrailingZero(sizeInMB) + " MB";
			} else {
				const sizeInGB = (size / (1024 * 1024 * 1024)).toFixed(2);
				return this.removeTrailingZero(sizeInGB) + " GB";
			}
		},
		// 删除文件
		deleteFile(index) {
			this.files.splice(index, 1);
		},
		// 修改点 3：handleSubmit 增加拦截逻辑
		handleSubmit() {
			// 安全拦截：如果有文件正在上传，弹窗提示并返回
			if (this.isUploading) {
				this.$message.warning("文件正在上传中，请稍候...");
				return;
			}

			if (this.files.length === 0) {
				this.$message.error("请先上传文件");
				return;
			}

			let fileArr = [];
			this.files.forEach((item) => {
				// 只有业务逻辑成功（code为0）的文件才会被提交
				if (item.code === "0") {
					fileArr.push({
						fileUrl: item.fileUrl,
					});
				}
			});

			// 如果上传了文件，但是接口返回全是失败的（比如格式错误），这里也会拦截
			if (fileArr.length === 0) {
				// 检查是否是因为所有文件都上传失败了
				// const hasErrorFiles = this.files.some(f => f.code && f.code !== "0");
				// if (hasErrorFiles) {
				//     this.$message.error("存在上传失败的文件，请删除后重试或上传有效文件");
				// } else {
				//     this.$message.error("请上传资料");
				// }
				this.$message.error("请上传资料");
				return;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload-dragger {
	display: flex;
	align-items: center;
	justify-content: space-around;
}

.upload-title {
	margin: 0 0 10px;
	font-weight: 600;
	color: #000;
	.tip {
		font-size: 14px;
		color: red;
	}
}

.upload-box {
	display: flex;
	gap: 20px;

	.upload-left {
		flex: 3;
		.upload-wrapper {
			width: 360px;
			.upload-info {
				display: flex;
				align-items: center;

				.upload-image {
					height: 40px;
				}

				.upload-tip {
					text-align: center;
					line-height: 20px;

					.message {
						font-size: 14px;
					}

					.tip {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.4);
					}
				}
			}
		}
	}
	.upload-right {
		flex: 2;
		border-left: 1px solid #f0f0f0;
		padding-left: 20px;
		.upload-files {
			max-height: 400px;
			overflow-y: auto;
		}
		.file-item {
			margin-bottom: 15px;
		}
		.file-name {
			display: flex;
			align-items: center;
			gap: 8px;
			font-size: 13px;
		}
		.file-perc {
			margin: 5px 0 0;
			span {
				font-size: 12px;
			}
		}
	}
}

.ddelete-icon {
	cursor: pointer;
	float: right;
}

.error {
	color: red;
	font-size: 12px;
	margin: 0;
}

.mt10 {
	margin-top: 10px;
}
</style>
